

export const scrollModule = {
    namespaced: true,
    state: {
        lenis: null,
        isCentered: false,
        optionsHorizontalScroll: {
            isTouch: false,
            isNext: false,
            wrapper: null,
            event: null,
            inHorizontalZone: false,
            scrollStart: 0,
            scrollEnd: 0,
            isScrolling: false,
            currentSlide: 0
        }
    },
    getters: {
    },
    mutations: {
        SET_OPTIONS_HORIZONTAL_SCROLL: (state, payload) => {
            state.optionsHorizontalScroll = {...state.optionsHorizontalScroll, ...payload}
        },
        SET_LENIS: (state, payload) => {
            state.lenis = payload;
        },
        SET_CENTERED: (state, payload) => {
            state.isCentered = payload;
        },
    },
    actions: {
        OPTIONS_HORIZONTAL_SCROLL: (context, payload) => {
            context.commit('SET_OPTIONS_HORIZONTAL_SCROLL', payload)
        },
        SET_LENIS: (context, payload) => {
            context.commit('SET_LENIS', payload)
        },
        SET_CENTERED: (context, payload) => {
            context.commit('SET_CENTERED', payload)
        },
    },
}
